import { toast } from 'react-toastify';

function handleRequestResult(json = { r: 0, message: "Ein Fehler ist aufgetreten" },
    success = () => { toast.success("Die Funktion wurde erfolgreich ausgeführt."); },
    error = () => { console.log("Es ist ein Fehler aufgetreten.") }) {
    if (json.r != 1) {
        if (json.message) {
            toast.info(json.message);
        }
        else {
            toast.error("Es ist ein Fehler aufgetreten.");
        }
        error();
    }
    else {
        success();
    }
}

export default handleRequestResult;